<template>
  <el-row class="mt-20 border-bottom" style="min-height: 100px">
    <el-col :md="12" :sm="12" :xs="24">
      <div class="text-center rectangle p-3 product">
        <img class="product-image" :src="productThumbnailImage" />
      </div>
      <div style="float: left; display: grid; margin-left: 10px">
        <span class="product-name"
          ><router-link :to="productView" class="product-link">
            {{ productName }}
          </router-link></span
        >
        <span class="secondary-info"> {{ origin }} </span>
        <span class="secondary-info-small">
          {{ uvcQty }}
          <img class="inventory-logo" :src="inventoryLogo" />
        </span>
      </div>
    </el-col>
    <el-col :md="8" :sm="8" :xs="12">
      <div style="display: grid">
        <span class="label"> {{ priceHeader }} </span>
        <span class="labelPrice">
          <span v-if="agencyFee">
            {{ $t("users.account.salesHistory.agencyFee") }}
            {{ formatAmount(agencyFee) }} /
            <span class="value"
              >{{ $t("users.account.salesHistory.saqValue") }}
              {{ formatAmount(productPrice) }}
            </span>
          </span>
        </span>
      </div>
    </el-col>
    <el-col :md="4" :sm="4" :xs="12">
      <div style="display: grid">
        <span class="label"> {{ totalHeader }} </span>
        <span class="subTotal">
          {{ formatAmount(salesProductLine.subTotal) }}</span
        >
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { get, find, isEmpty } from "@/utils/lodash";

import { formatCurrency } from "@/utils/common-utils";
import goTo from "../../../mixins/goTo";
export default {
  mixins: [goTo],
  components: {},
  props: {
    salesProductLine: {
      type: Object,
      default: () => {},
    },
    product: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    productView() {
      return {
        name: "product",
        params: {
          slug: get(this.product, "slug", ""),
          productType: this.productType,
        },
        query: {
          id: get(this.product, "puid")
            ? get(this.product, "puid")
            : get(this.product, "id").toString(),
          productType:
            get(this.product, "puid") && this.productType != ""
              ? this.productType
              : undefined,
          pid: get(this.product, "id").toString()
        },
      };
    },
    productThumbnailImage() {
      return get(this.product, "image.thumbnailLink");
    },
    productName() {
      return get(this.product, "name");
    },
    providerName() {
      return get(this.salesProductLine, "product.provider.aliasName");
    },
    origin() {('this', this.product);
      
      if (isEmpty(this.product.origins)) {
        return "";
      }
      const country = this.product.origins[0].country.name;
      const region = this.product.origins[0].country.name;

      return `${country}, ${region}`;
    },
    uvc() {
      return get(this.product, "uvc");
    },
    uvcQty() {
      return this.$i18n.tc(
        "users.account.salesHistory.qty",
        Math.round(this.salesProductLine.qty / this.uvc),
        {
          x: Math.round(this.salesProductLine.qty / this.uvc),
          n: this.uvc,
        }
      );
    },
    inventoryLogo() {
      if (
        this.salesProductLine.inventory != null &&
        this.salesProductLine.inventory.code === "IP"
      ) {
        /* eslint-disable global-require */
        return require("@/assets/images/inventory-IP.png");
      }
      /* eslint-disable global-require */
      return require("@/assets/images/inventory-IP.png");
    },
    priceHeader() {
      return this.$i18n.t("users.account.salesHistory.price").toUpperCase();
    },
    totalHeader() {
      return this.$i18n
        .t("users.account.salesHistory.salesOrderTotalHeader")
        .toUpperCase();
    },
    agencyFee() {
      const agencyFee = find(
        this.salesProductLine.prices,
        (price) => price.label === "PRODUCT_AGENCY_FEE"
      );
      return get(agencyFee, "price");
    },
    productPrice() {
      const productPrice = find(
        this.salesProductLine.prices,
        (price) => price.label === "DEFAULT_PRODUCT_PRICE"
      );
      return get(productPrice, "price");
    },
  },
  methods: {
    formatAmount(amount) {
      return formatCurrency(amount, this.$i18n.locale);
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/variables.scss";

.product {
  float: left;
}
.product-image {
  max-width: 53px;
  max-height: 53px;
}

.rectangle {
  width: 61px;
  height: 61px;
  background-color: rgba(237, 240, 237, 0.33);
}

.product-name {
  color: $color-primary;
  letter-spacing: 0.25px !important;
  font-family: "Futura Std ", "Futura Std", sans-serif;
  line-height: normal;
  font-size: 16px;
}

.secondary-info {
  font-family: "Futura Std ", "Futura Std", sans-serif;
  font-weight: 300;
  color: rgba(39, 36, 33, 0.7);
  text-align: left;
  line-height: normal;
  letter-spacing: 0.1px;
  font-size: 14px;
  margin-top: 3px;
}

.secondary-info-small {
  font-family: "Futura Std ", "Futura Std", sans-serif;
  font-weight: 500;
  color: rgba(39, 36, 33, 0.7);
  text-align: left;
  line-height: normal;
  letter-spacing: 0.4px;
  font-size: 12px;
  margin-top: 3px;
}

.inventory-logo {
  height: 15px;
  width: 15px;
  position: relative;
  top: 3px;
  margin-left: 3px;
  margin-right: 3px;
}

.label {
  font-family: "Futura Std ", "Futura Std", sans-serif;
  font-weight: 300;
  color: rgba(39, 36, 33, 0.7);
  text-align: left;
  line-height: normal;
  letter-spacing: 1.5px;
  font-size: 10px;
}

.labelPrice {
  font-family: "Futura Std ", "Futura Std", sans-serif;
  font-weight: 500;
  color: #272421;
  text-align: left;
  line-height: normal;
  letter-spacing: 0.4px;
  font-size: 12px;
}

.subTotal {
  font-family: "Futura Std ", "Futura Std", sans-serif;
  color: #272421;
  line-height: normal;
  letter-spacing: 0.25px;
  font-size: 16px;
}

.value {
  color: rgba(39, 36, 33, 0.7);
}
.product-link {
  color: #606266;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
}
</style>
